module.exports = __webpack_public_path__ + "static/media/map.5ecca812.svg";